import axios from "axios";
import type { RichText } from "../../types";

export interface Blogpost {
   author: string | null;
   blogpostLocaleId: string;
   blogpostVersionId: string;
   blogpostVersion: number;
   content: {
      body: RichText;
      header?: RichText;
   };
   createdAt: string;
   createdById: string | null;
   datePublished: string;
   id: string;
   imageHero_620w: string;
   imageHeroRatio: number;
   imageThumbnail_400w_300h: string;
   isArchived: boolean;
   isB2bBlog: boolean;
   isDraft: boolean;
   isPressBlog: boolean;
   isPubliclyListed: boolean;
   isUserBlog: boolean;
   key: string;
   localeId: string;
   lockedById: string | null;
   published: boolean;
   references: string[] | null;
   relatedBlogposts: string[] | null;
   socialShareText: string;
   subtitle: string;
   tags: string[] | null;
   title: string;
   updatedAt: string;
}

export default class BlogpostsApi {
   public static getOneByKey = async (key: string): Promise<Blogpost> => {
      const response = await axios.get(`/blogposts/by/key/${key}`);
      return response.data?.data;
   };
   public static getOneById = async (id: string): Promise<Blogpost> => {
      const response = await axios.get(`/blogposts/${id}`);
      return response.data?.data;
   };
}
